export default "__VITE_ASSET__bfd54d89__"